import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {LoadUsers} from '../actions/users.actions';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';

@Injectable()
export class UsersGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkUsers()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkUsers(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectUsersLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadUsers());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
